import React from 'react';

const MessageParser = ({ children, actions }) => {
    const parse = (message) => {
        // Pass user message to action handler
        actions.handleUserMessage(message);
    };

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    parse: parse,
                    actions: {},
                });
            })}
        </div>
    );
};

export default MessageParser;